module.exports = __webpack_public_path__ + "static/vg-03583eec8045939407f03a11487ab2ae.svg";